<script setup lang="ts"></script>

<template>
  <SongDetailsAlert
    message-variant="bg-warning"
    :title="$t('SV.MES_PurchaseRequired')"
    icon="fa-light fa-info-circle"
    :button-label="$t('S.LIT_Upgrade')"
    button-variant="orange"
    button-icon="fa-solid fa-cart-shopping me-2"
    to="/about/pricing"
  />
</template>

<style scoped lang="postcss"></style>
